module.exports = require("jquery");


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 6
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "jquery"